import { Controller } from "@hotwired/stimulus";

export default class extends Controller {

  connect() {
    this.fetchNotificationsCount();
  }

  fetchNotificationsCount() {
    if ($("#notificationCount")[0]) {
      $.ajax({
        url: "/api/staff/v1/notifications/count",
        success: function(response) {
          if (response.count > 0) {
            return $("#notificationCount").text(response.count);
          }
        }
      });
    }
  }
}
